import React from 'react'
import {Icon} from '@components/common/base/icon'
import {TwSeenBy} from './containers'
import {SeenBy as SeenByEnum} from './types'

interface Props {
  seenBy: SeenByEnum
  title?: string
  className?: string
}

export const SeenBy = ({seenBy, title, className}: Props) => {
  const icon = seenBy === 'everybody' ? 'IconChecks' : 'IconCheck'
  const color = seenBy === 'nobody' ? 'placeholder' : 'action-default'

  return (
    <TwSeenBy componentTag="span" content={title} className={className}>
      <Icon icon={icon} size={16} color={color} className="flex items-center" />
    </TwSeenBy>
  )
}
